export enum Days {
  MONDAY = 'days.monday',
  TUESDAY = 'days.tuesday',
  WEDNESDAY = 'days.wednesday',
  THURSDAY = 'days.thursday',
  FRIDAY = 'days.friday',
  SATURDAY = 'days.saturday',
  SUNDAY = 'days.sunday',
  ALLDAY = '24',
}

export const listOfDay = [
  Days.MONDAY,
  Days.TUESDAY,
  Days.WEDNESDAY,
  Days.THURSDAY,
  Days.FRIDAY,
  Days.SATURDAY,
  Days.SUNDAY,
  Days.ALLDAY
];

export function getActiveDayIndex(day: string): number {
  switch (day) {
    case 'days.monday':
      return 0;
    case 'days.tuesday':
      return 1;
    case 'days.wednesday':
      return 2;
    case 'days.thursday':
      return 3;
    case 'days.friday':
      return 4;
    case 'days.saturday':
      return 5;
    case 'days.sunday':
      return 6;
  }
}
